module.exports = __webpack_public_path__ + "static/media/dashed-circle.b228eb21.svg";